<script>
import { Col, Container, Row } from "sveltestrap";
import { _ } from "svelte-i18n";
</script>

<section class="my-5">
  <Container class="mb-5">
    <Row>
      <Col xs="8">
        <h2>{$_("Informed_title")}</h2>
        <form
          action="https://bikedataproject.us10.list-manage.com/subscribe/post?u=0c7a4077dc373a78e97129b40&amp;id=48e38aad42"
          method="post"
          class="Home_form__3a7DN"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          target="_blank">
          <div class="d-none" aria-hidden="true">
            <input
              type="text"
              name="b_4e280417525a8a98031f1ce33_9af7c29f8d"
              tabindex="-1"
              value="" />
          </div>
          <label for="mce-EMAIL">{$_("Email_label")}</label>
          <div>
            <input
              type="email"
              placeholder="{$_("Informed_placeholder")}"
              name="EMAIL"
              id="mce-EMAIL"
              required="" />
            <button>
              <img
                src="/img/arrow-orange.svg"
                alt="Arrow orange icon"
                width="20"
                height="20" />
            </button>
          </div>
        </form>
      </Col>
    </Row>
  </Container>
</section>

<style>
.my-5 {
  margin-bottom: 10rem !important;
}

label {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 1.4rem;
}

input {
  background: transparent;
  border: none;
  border-bottom: 0.1rem solid #ef4823;
  padding: 1.5rem;
  outline: none;
  color: #000;
  width: 100%;
}

button {
  background: transparent;
  border: none;
  margin-left: -5rem;
}
</style>
